export default __webpack_public_path__ + "_/react/assets/svg/images/youtube-v3.png";